/*
 * @Author: Gao Deng gaodeng@nextmar.com
 * @Date: 2025-05-08 17:05:46
 * @LastEditors: Gao Deng gaodeng@nextmar.com
 * @LastEditTime: 2025-05-09 17:13:19
 * @FilePath: \zeelool-nextjs\src\components\Layout\Header\CountDown.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useTranslations } from '@/i18n/use-translations';
import { useEffect, useState } from 'react';

// TODO:是否可以和components/CountDown.tsx合并？
const CountDown = ({
  time = 0,
  textColor = '#282828',
  onCountDownEnd,
}: {
  time: number;
  textColor?: string;
  onCountDownEnd?: () => void;
}) => {
  const [day, setDay] = useState(0);
  const [hour, setHour] = useState(0);
  const [minute, setMinute] = useState(0);
  const [second, setSecond] = useState(0);
  const [timer, setTimer] = useState(null);
  const t = useTranslations('layout.header');

  const handleCountDown = (val: number) => {
    if (val < 0) {
      return;
    }
    if (val === 0) {
      // 倒计时结束，通知父组件
      onCountDownEnd?.();
    }
    setDay(Math.floor(val / (60 * 60 * 24)));
    setHour(Math.floor((val / (60 * 60)) % 24));
    setMinute(Math.floor((val / 60) % 60));
    setSecond(Math.floor(val % 60));
    setTimer(
      setTimeout(() => {
        handleCountDown(val - 1);
      }, 1000),
    );
  };

  useEffect(() => {
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    handleCountDown(time);
  }, [time]);

  return (
    <div
      className="flex items-center justify-center text-[3.2vw] lg:text-[12px] lg:ml-[72px] font-fb"
      style={{ color: textColor }}
    >
      {day > 0 && (
        <>
          <span>{day}</span>
          <span className="mr-[5px]">{day > 1 ? t('days') : t('day')}</span>
        </>
      )}
      <span className=" text-center min-w-[4.267vw] lg:min-w-[20px]">
        {hour.toString().padStart(2, '0')}
      </span>
      <span>:</span>
      <span className="text-center min-w-[4.267vw] lg:min-w-[20px]">
        {minute.toString().padStart(2, '0')}
      </span>
      <span>:</span>
      <span className="text-center min-w-[4.267vw] lg:min-w-[20px]">
        {second.toString().padStart(2, '0')}
      </span>
    </div>
  );
};

export default CountDown;
